<script>
export default {
  name: 'EventLiveBets',
  props: {
    liveBets: {
      type: Array,
      required: true,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    usersLength() {
      return this.liveBets.length;
    },
    usersText() {
      const { usersLength, liveBets } = this;
      if (usersLength === 1) {
        return liveBets[0].username;
      }
      if (usersLength === 2) {
        return `${liveBets[0].username} and ${liveBets[1].username}`;
      }
      if (usersLength > 2) {
        return `${liveBets[0].username} + ${usersLength - 1}`;
      }
      return '';
    },
  },
};
</script>


<template>
  <div :class="{'mobile-event-live-bets': isMobile}" class="event-live-bet-container">
    <div class="event-live-bet-images">
      <template v-for="(bet, index) in liveBets.slice(0, 4)">
        <img
          :key="`bet-user-img-${index}`"
          :src="bet.imageUrl"
          :class="`img-loc-${index}`"
          class="event-live-bet-image"
        >
      </template>
    </div>
    <div class="event-live-bet-users">{{ usersText }}</div>
  </div>
</template>
